import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { useState, } from 'react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from '../components/snackbar';
import LoadingButton from '@mui/lab/LoadingButton';
import { Dialog, TextField, DialogActions, DialogContent, DialogTitle, Alert, Grid, Box, IconButton, Typography, Stack, } from '@mui/material';
import axios from 'axios';
import Iconify from '../components/iconify';



// ----------------------------------------------------------------------

export default function EditUPIDialog({isOpen, onClose,onEditUPISuccess, ...other }) {
    const SERVER_URI = process.env.REACT_APP_SERVER_URI;
    const ADD_UPI = `${SERVER_URI}/addUPI`;
    

    const { enqueueSnackbar } = useSnackbar();

    //   const token = window.localStorage.getItem('accessToken');

    const [userUPI, setUserUPI] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const handleCloseDialog = () => {
        onClose()
    };





    const UpdateUserSchema = Yup.object().shape({
        upi: Yup.string()
        .matches(
            /^[\w.-]+@[\w.-]+$/,
            "Invalid UPI format. Example: name@bank or mobilenumber@bank"
          )
        .required(' UPI is required'),

    });


    const defaultValues = {
        upi: '',

    };

    const {
        handleSubmit,
        control,
        formState: { isSubmitting, errors },
        // reset,
        // trigger,
        // getValues,
    } = useForm({
        resolver: yupResolver(UpdateUserSchema),
        defaultValues,
        mode: "onChange",
        reValidateMode: "onChange",
    });



    const onSubmit = handleSubmit(async (data) => {
       let token = localStorage.getItem("accessToken");
        let config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        try {
            setLoading(true);
            const { upi } = data;
            // const dataSubmit = new FormData();
            // dataSubmit.append('upi', upi);
            const dataSubmit = { upi };
            setErrorMsg('');

            const response = await axios.post(ADD_UPI, dataSubmit,config,{ withCredentials: true }
            );
            handleCloseDialog();
            setErrorMsg('');
            setUserUPI(response?.data?.data);
            onEditUPISuccess();
            enqueueSnackbar(response?.data?.message, { variant: 'success' });
        } catch (error) {
            console.log(error);
            if (!navigator.onLine) {
                setErrorMsg('You are currently offline. Please check your network connection.');
            } else if (error) {
                setErrorMsg(error.response.data.error || 'An error occurred while processing your request.');
                enqueueSnackbar(error.response.data.error, { variant: 'error' });
            } else {
                setErrorMsg('An unexpected error occurred.');
            }
        } finally {
            setLoading(false);
        }
    });

    return (
        <>
            <Dialog
                // fullWidth
                maxWidth={false}
                open={isOpen}
                onClose={onClose} {...other}
                disableEscapeKeyDown // Prevent closing with the Escape key
             
                PaperProps={{
                    sx: { maxWidth: 720, minWidth:{xs:250, lg:468}, borderRadius: 5, p: '28px' },
                }}
            >
                <form onSubmit={onSubmit}>
                    <DialogTitle
                        sx={{
                            color: '#1E53E8',
                            fontSize: 24,
                            fontFamily: 'Roboto Flex',
                            fontWeight: '700',
                            lineHeight: '18px',
                            wordWrap: 'break-word',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between', // Space between text and button
                                alignItems: 'center',
                            }}
                        >
                           Edit UPI ID

                            <IconButton
                                sx={{
                                    backgroundColor: '#f1f1f1',
                                    color: '#919191',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        transition: 'color 0.3s ease',
                                        color: 'red',
                                    },
                                }}
                                onClick={handleCloseDialog}
                            >
                                <Iconify icon={'material-symbols:close'} />
                            </IconButton>
                        </Box>
                    </DialogTitle>


                    <DialogContent>
                        {errorMsg &&
                            <Alert variant="outlined" severity="error" sx={{ mb: 3 }}>
                                {errorMsg}
                            </Alert>}

                        <Grid item xs={12} md={12} sx={{pt:2}}>
                            <Box >
                                <Stack direction="column" spacing={1}>

                                    <Controller
                                        name="upi"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                id="upi_text"
                                                variant="outlined"
                                                size="medium"
                                                fullWidth
                                                error={!!errors.upi}
                                                helperText={errors.upi?.message}

                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: 3,
                                                        "& .MuiInputBase-input": {
                                                            color: '#1E53E8',
                                                            fontSize: '18px',
                                                            fontFamily: 'Roboto Flex',
                                                            fontWeight: '600',
                                                            lineHeight: '18px',
                                                            wordWrap: 'break-word'
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                    <Typography
                                        component="label"
                                        htmlFor="upi_text"
                                        sx={{
                                            color: '#858585',
                                            fontSize: 18,
                                            fontFamily: 'Roboto Flex',
                                            fontStyle: 'italic',
                                            fontWeight: '600',
                                            lineHeight: '18px',
                                            wordWrap: 'break-word'
                                        }}
                                    >
                                        Your information is safe with us!
                                    </Typography>
                                </Stack>
                            </Box>
                        </Grid>

                    </DialogContent>

                    <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                        <Grid container item md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <LoadingButton type="submit" variant="contained" loading={isSubmitting} fullWidth onClick={onSubmit}
                                sx={{
                                    color: "#1E53E8",
                                    fontWeight: "bold",
                                    background: "#C7F760",
                                    padding: 1,
                                    borderRadius: 2,
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        transition: 'color 0.3s ease',
                                        color: '#C7F760',
                                    },
                                }}
                            >
                                Confirm
                            </LoadingButton>
                        </Grid>
                    </DialogActions>

                </form>
            </Dialog>


        </>
    );
}

EditUPIDialog.propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    onEditUPISuccess: PropTypes.func,
};
